import styled from 'styled-components'

import { Checkbox as AntCheckbox, Input as AntInput } from 'antd'
import Text from 'antd/lib/typography/Text'

export const Checkbox = styled(AntCheckbox)`
  width: 100%;
`

export const Input = styled(AntInput)`
  margin-bottom: 8px;
`

export const Username = styled(Text)`
  margin-left: 8px;
`
